import { Game } from "@aura-frontend/omnibus-az-client";

function formatTime(sec: number): string {
  return new Date(sec * 1000).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
}

export function getEventLabel(event: Game): string {
  if (event.type === "game") {
    return event.generated_display_name || event.displayName || event.type;
  }
  return event.generated_display_name || "Practice";
}

export function getEventTimeRange(event: Game): string {
  const firstTime = event.times[0];
  const lastTime = event.times.at(-1);

  const start = firstTime?.startTime;
  const end = lastTime?.endTime;

  if (!start) return "";
  return end ? `${formatTime(start)} – ${formatTime(end)}` : formatTime(start);
}
